import { render, staticRenderFns } from "./HeroImpactoBot.vue?vue&type=template&id=f23b48be&scoped=true"
import script from "./HeroImpactoBot.vue?vue&type=script&lang=js"
export * from "./HeroImpactoBot.vue?vue&type=script&lang=js"
import style0 from "./HeroImpactoBot.vue?vue&type=style&index=0&id=f23b48be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b48be",
  null
  
)

export default component.exports